import React, { useEffect, useState } from "react";
import { Sparkle } from "lucide-react";

// Importing the images
import Agric from "../assets/tracks/Agri-engenerring.webp";
import Aero from "../assets/tracks/Areospace-enegneering-02.webp";
import Auto from "../assets/tracks/Automobile-engeneering.webp";
import BigData from "../assets/tracks/Big-data.webp";
import Chemical from "../assets/tracks/Chemical-engineering.webp";
import civil from "../assets/tracks/civil-eng.webp";
import communication from "../assets/tracks/Communication-1.webp";
import industry from "../assets/tracks/Industrial-engeneering.webp";
import It from "../assets/tracks/Information-Technology.webp";
import blockchain from "../assets/tracks/m1.webp";
import indu from "../assets/tracks/m2.webp";
import Ai from "../assets/tracks/m3.webp";
import machine from "../assets/tracks/machine-laerning.webp";
import marine from "../assets/tracks/Marine-image-3.webp";
import mech from "../assets/tracks/mech-.-image.webp";
import nano from "../assets/tracks/nano-eng.webp";
import Robotics from "../assets/tracks/Robotics.webp";
import iot from "../assets/tracks/The-Internet-of-Things.webp";
import { Link } from "react-router-dom";

const routes = {
  about: "/about-Quantumtech-conclave",
  orators: "/Quantumtech-orators",
  home: "/",
  register: "https://helixconferences.com/buy-a-ticket",
  executive: "/executive-panel-members/",
  tracks: "/Quantumtech-conference-tracks/",
  venue: "/venue",
  schedule: "/Quantumtech-event-schedule",
  contact: "/contact",
};
export const tracks = [
  {
    image: Ai,
    title: "Quantum AI",
    description: (
      <>
        Explore the frontier where quantum computing meets artificial
        intelligence. <Link to={routes.about} className="
             hover:text-accent hover:decoration-accent
             transition-colors duration-300">Quantum AI</Link> leverages quantum algorithms to accelerate machine learning, optimize complex problems, and revolutionize data analysis. Join experts uncovering transformative possibilities, from faster computations to breakthroughs in cryptography, healthcare, and beyond, shaping the next era of intelligent technology.
      </>
    ),
  },

  {
    image: communication,
    title: "Communication & Networking",
    description: (
      <>
        Explore the dynamic field of {" "}
        <Link to={routes.contact} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Communication and Networking</Link> where connectivity powers innovation. This track covers network architectures, protocols, wireless technologies, and data transmission strategies. Learn how seamless communication drives collaboration, IoT, cloud computing, and digital transformation, enabling faster, more reliable, and secure connections across industries worldwide.
      </>
    ),
  },

  {
    image: Chemical,
    title: "Core Quantum Science",
    description: (
      <>
        Dive into the fundamentals of quantum science, exploring the principles that govern the quantum realm. From superposition and entanglement to quantum materials and technologies, this track unveils the mysteries of the {" "}
        <Link to={routes.orators} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">microscopic world</Link>,fostering insights that drive innovation in computing, communication, sensing, and the next generation of scientific discovery.
      </>
    ),
  },

  {
    image: "https://www.shutterstock.com/image-illustration/post-quantum-cryptography-resistant-shield-600nw-2572533271.webp",
    title: "Cryptography & Cybersecurity",
    description: (
      <>
        Explore the cutting-edge of {" "}
        <Link to={routes.register} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Cryptography and Cybersecurity</Link>,where protecting data meets innovation. This track covers encryption, secure communication, threat detection, and risk mitigation strategies. Learn from experts about defending against cyber threats, safeguarding digital assets, and building resilient systems that ensure privacy, trust, and security in an increasingly connected world.
      </>
    ),
  },

  {
    image: industry,
    title: "Industry & Future",
    description: (
      <>
        Discover the {" "}
        <Link to={routes.contact} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Industry & Future</Link> track, exploring how emerging technologies shape tomorrow’s world. From quantum innovations to AI, automation, and sustainable solutions, this track examines trends transforming industries. Gain insights into future-ready strategies, cutting-edge applications, and the evolving landscape of science and technology that will define the next era of progress.
      </>
    ),
  },

  {
    image: iot,
    title: "Quantum Computation",
    description: (
      <>
        Unlock the future of computing with {" "}
        <Link to={routes.executive} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Quantum Computation</Link>. Explore quantum algorithms, qubits, and computational models that outperform classical systems. This track delves into solving complex problems, optimizing processes, and advancing simulations across industries. Join experts to understand how quantum computing is reshaping technology, innovation, and the limits of computation.
      </>
    ),
  },

  {
    image: indu,
    title: "Quantum Biology",
    description: (
      <>
        Dive into {" "}
        <Link to={routes.register} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Quantum Biology</Link>
        , where quantum principles illuminate life’s mysteries. Explore how quantum phenomena influence photosynthesis, enzyme activity, and cellular processes. This track uncovers the intersection of biology and quantum mechanics, offering insights into fundamental life processes and inspiring innovations in medicine, biotechnology, and our understanding of the natural world.


      </>
    ),
  },

  {
    image: It,
    title: "Software Development",
    description: (
      <>
        Dive into the world of {" "}
        <Link to={routes.register} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Software Development</Link>
        where ideas transform into innovative applications. Explore programming, frameworks, agile methodologies, and best practices that drive efficient, scalable, and secure solutions. This track equips participants with the skills to build cutting-edge software, optimize workflows, and shape the future of technology across industries.
      </>
    ),
  },

  {
    image: "https://media.istockphoto.com/id/1387900612/photo/automation-data-analytic-with-robot-and-digital-visualization-for-big-data-scientist.jpg?s=612x612&w=0&k=20&c=50maOJU6CpVC55mYnUqtff2aiaJZ7KlmMn4jNhWD_eo=",
    title: "Machine Learning",
    description: (
      <>
        Discover the transformative power of {" "}
        <Link to={routes.home} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Machine Learning</Link> , where data drives intelligent decisions. Explore algorithms, predictive modeling, and AI-driven insights that optimize industries, enhance automation, and unlock new possibilities. This track connects theory with real-world applications, empowering participants to harness data, innovate solutions, and shape the future of technology.
      </>
    ),
  },

  {
    image: Robotics,
    title: "Robotics & Automation",
    description: (
      <>
        <Link to={routes.home} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Robotics & Automation</Link> focuses on designing intelligent machines and automated systems that perform tasks with precision, speed, and efficiency. It covers robotics, control systems, AI-driven automation, and real-world applications across manufacturing, healthcare, logistics, and smart industries.
      </>
    ),
  },

  {
    image: "https://media.istockphoto.com/id/2149753998/photo/physics-quantum-and-quantum-entanglement-3d-rendering.jpg?s=612x612&w=0&k=20&c=AQIxkAxzwQC_jICCCeKA28IptXZl1MPpvvpSGiSDDy4=",
    title: "Optics & Photonics",
    description: (
      <>
        Explore the fascinating world of {" "}
        <Link to={routes.tracks} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Optics and Photonics</Link> where light drives innovation. This track covers lasers, fiber optics, imaging, and optical communication technologies. Learn how photonic systems revolutionize computing, healthcare, and   <Link to={routes.schedule}>telecommunications,</Link> enabling faster data transmission, advanced sensing, and groundbreaking research in science and technology.
      </>
    ),
  },

  {
    image: "https://bloximages.newyork1.vip.townnews.com/santafenewmexican.com/content/tncms/assets/v3/editorial/d/da/dda0d32a-bb90-50bc-81d8-ab4aaf370425/58733431bdd0c.image.webp",
    title: "Quantum Cosmology",
    description: (
      <>
        Explore.{" "}
        <Link to={routes.schedule} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Quantum Cosmology</Link> , where quantum mechanics meets the universe’s origins. This track investigates the quantum nature of space-time, the Big Bang, black holes, and cosmic evolution. Discover how quantum theories provide insights into the universe’s fundamental structure, bridging cosmology, particle physics, and gravity, and reshaping our understanding of reality itself.
      </>
    ),
  },

  {
    image: machine,
    title: "Quantum Sensing and Metrology",
    description: (
      <>
        Discover{" "}
        <Link to={routes.orators} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Quantum Sensing and Metrology</Link> , where precision reaches unprecedented levels. Explore quantum-enhanced measurement techniques, sensors, and devices that surpass classical limits. This track highlights applications in navigation, medical imaging, and fundamental physics, demonstrating how quantum technologies are transforming measurement accuracy, enabling breakthroughs, and driving innovation across science and industry.
      </>
    ),
  },

  {
    image: "https://media.istockphoto.com/id/1130957259/photo/composition-with-tools-and-industrial-material-with-industrial-ship-background.jpg?s=612x612&w=0&k=20&c=XDZNptsfq3TASTKWGsmnDajREC820JuDQf9IyRanCsg=",
    title: "Materials & Devices",
    description: (
      <>
        Explore the Materials & Devices track, where innovation meets functionality. Delve into advanced materials, nanotechnology, and device engineering that drive breakthroughs in electronics, energy, and quantum technologies. Learn how cutting-edge materials enable next-generation devices, enhancing performance, efficiency, and sustainability across industries, shaping the future of {" "}
        <Link to={routes.venue} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">science and technology</Link>.
      </>
    ),
  },

  {
    image: Agric,
    title: "Quantum Agriculture",
    description: (
      <>
        Explore{" "}
        <Link to={routes.executive} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Quantum Agriculture</Link>, where quantum technologies revolutionize farming and food production. This track examines precision agriculture, quantum sensing for soil and crop monitoring, and advanced modeling for sustainable yields. Discover how quantum innovations enhance efficiency, resource management, and environmental sustainability, shaping the future of agriculture and global food security.
      </>
    ),
  },

  {
    image: nano,
    title: "Quantum Chemistry",
    description: (
      <>
        Explore Quantum Chemistry, where quantum mechanics meets molecular science. This track delves into electronic structures, chemical reactions, and computational modeling at the quantum level. Discover how quantum approaches accelerate drug discovery, materials design, and chemical innovation, offering deeper insights into molecular behavior and shaping the future of {" "}
        <Link to={routes.home} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">chemistry and technology.</Link>
      </>
    ),
  },

  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0420t0qZaLfkok56Xi40SW65iOzsvPUgAZA&s",
    title: "Quantum Applications",
    description: (
      <>
        Explore Quantum Applications, where theory meets real-world innovation. This track highlights practical uses {" "}
        <Link to={routes.venue} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">quantum technologies</Link>across computing, communication, sensing, and cryptography. Learn how quantum solutions are transforming industries, solving complex problems, and enabling breakthroughs in healthcare, finance, and materials science, shaping the future of technology and scientific discovery.
      </>
    ),
  },

  {
    image: "https://quantumzeitgeist.com/wp-content/uploads/edukatin.webp",
    title: "Quantum Education & Training",
    description: (
      <>

        <Link to={routes.home} className="
             hover:text-one hover:decoration-accent
             transition-colors duration-300">Quantum Education & Training</Link> dedicated to building the next generation of quantum experts. This track covers learning programs, workshops, and skill development in quantum technologies. Gain hands-on knowledge, practical insights, and theoretical foundations to drive innovation, empower careers, and shape the future of quantum science and its applications worldwide.
      </>
    ),
  },
];

const StaticTracks = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* <style>{`
        @keyframes pulseShadow {
          0%, 100% {
            box-shadow: 0 0 0px rgba(44, 211, 35, 0.2);
          }
          50% {
            box-shadow: 0 0 18px 6px rgb(122,179,38);
          }
        }

        .animate-pulseShadow {
          animation: pulseShadow 3s ease-in-out infinite;
        }

        .transition-custom {
          transition: all 0.8s ease-in-out;
        }
      `}</style> */}

      <div className="relative mt-14">
        {/* Fixed Top-Right Button */}
        <div className="fixed top-[22%] right-[1%] z-50 transition-custom">
          <a
            href="/abstract-submission"
            aria-label="Submit abstract"
            className="bg-one rounded-full text-white text-sm font-medium px-3 py-3 select-none transition-transform hover:scale-110 animate-pulseShadow"
          >
            Submit Abstract
          </a>
        </div>

        {/* Track Content */}
        <div className="container mx-auto px-4 py-10 space-y-20 flex flex-col items-center">
          {tracks.map((track, index) => (
            <div
              key={index}
              className="relative w-[80%] flex flex-col md:flex-row items-stretch md:space-x-6"
            >
              <div className="flex-shrink-0 bg-white border shadow-xl rounded-2xl p-2 w-full md:w-1/3">
                <img
                  src={track.image}
                  alt={track.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <div className="bg-white border shadow-xl rounded-2xl p-6 w-full md:w-2/3 mt-12 md:mt-0 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-1 text-one flex items-center gap-2">
                  <Sparkle className="fill-one" />
                  {track.title}
                </h2>
                <h3 className="text-xl text-gray-600 font-semibold mb-3">
                  {track.subtitle}
                </h3>
                <p className="text-md text-gray-800 leading-relaxed text-justify">
                  {track.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StaticTracks;
